import { UNAUTHORIZED } from '../constants/httpStatusCodes'
import { tokenRevoke } from './authorization'

export const getErrorAction = (error, handler, payload) => {
  return (error.status === UNAUTHORIZED)
    ? tokenRevoke()
    : handler({ ...payload, response: error.xhr.response, status: error.status })
}



// WEBPACK FOOTER //
// ./src/store/errorMapper.js